"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContractsEndpoint = getContractsEndpoint;
exports.getContractsCountEndpoint = getContractsCountEndpoint;
exports.getInterveningPartiesEndpoint = getInterveningPartiesEndpoint;
exports.getContractHandoverEndpoint = getContractHandoverEndpoint;
exports.getPayOffProposalPdfEndpoint = getPayOffProposalPdfEndpoint;
function getContractsEndpoint() {
    return "/contracts";
}
function getContractsCountEndpoint() {
    return `${getContractsEndpoint()}/count`;
}
function getInterveningPartiesEndpoint(contractId) {
    return `${getContractsEndpoint()}/${contractId}/intervening-parties`;
}
function getContractHandoverEndpoint(contractId) {
    return `${getContractsEndpoint()}/${contractId}/handover`;
}
function getPayOffProposalPdfEndpoint(contractId) {
    return `${getContractsEndpoint()}/${contractId}/documents/pay-off-proposal`;
}
//# sourceMappingURL=contracts.js.map